import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  MyMeasuresActions,
  MyMeasuresActionTypes
} from './my-measures.actions';
import { MyMeasuresCategory, MyMeasuresEntry } from './my-measures.models';

interface MyMeasuresState {
  graph: any;
  list: Array<MyMeasuresEntry>;
  categories: Array<MyMeasuresCategory>;
  selectedCategory: MyMeasuresCategory;
  selectedMeasure: MyMeasuresEntry;
}

export const myMeasuresInitialState: MyMeasuresState = {
  graph: undefined,
  list: undefined,
  categories: undefined,
  selectedCategory: undefined,
  selectedMeasure: undefined
};

export function myMeasuresReducer(
  state = myMeasuresInitialState,
  action: MyMeasuresActions
): MyMeasuresState {
  switch (action.type) {
    case MyMeasuresActionTypes.LOAD_CHART:
      return { ...state, graph: undefined };

    case MyMeasuresActionTypes.LOAD_CHART_SUCCESS:
      return { ...state, graph: action.payload };

    case MyMeasuresActionTypes.LOAD_MEASURES_LIST_SUCCESS:
      return { ...state, list: action.payload };

    case MyMeasuresActionTypes.LOAD_CATEGORIES_SUCCESS:
      return { ...state, categories: action.payload };

    case MyMeasuresActionTypes.SET_SELECTED_CATEGORY:
      return { ...state, selectedCategory: action.payload };

    case MyMeasuresActionTypes.SET_SELECTED_MEASURE:
      return { ...state, selectedMeasure: action.payload };

    case MyMeasuresActionTypes.RESET_MY_MEASURES_STORE:
      return myMeasuresInitialState;

    default:
      return state;
  }
}

const myMeasuresState = createFeatureSelector<MyMeasuresState>('myMeasures');

export const selectorMyMeasureGraph = createSelector(
  myMeasuresState,
  state => state.graph
);

export const selectorMyMeasuresList = createSelector(
  myMeasuresState,
  state => state.list
);

export const selectorCategoriesList = createSelector(
  myMeasuresState,
  state => state.categories
);

export const selectorCategoryMeasuresList = (categoryUuid: string) =>
  createSelector(myMeasuresState, state => {
    const category =
      state.categories &&
      state.categories.find(cat => cat.uuid === categoryUuid);
    return (category && category.measures) || [];
  });

export const selectorMyMeasuresSelectedMeasure = createSelector(
  myMeasuresState,
  state => state.selectedMeasure
);

export const selectorMyMeasuresSelectedCategory = createSelector(
  myMeasuresState,
  state => state.selectedCategory
);
